//export const API_URL = 'http://localhost:3001';
export const API_URL = `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}`;
